import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import { createAppContainer } from '@react-navigation/native';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import { t } from 'Locale';
import PropTypes from 'prop-types';
import { ManageFavorites, ChannelOrder } from 'Pages';
import { DEFAULT_FAV_SETTINGS_TAB } from '../../favoriteSettingsOptions';
import { topTabBarOptionsWeb } from '../../../../Navigation/navigationOptions';
import TabBarComponent from '../../../../Navigation/tabBar';

const Tab = createMaterialTopTabNavigator();
const TabIptv = createMaterialTopTabNavigator();

const drawConfig = {
    tabBarPosition: 'top',
    sceneContainerStyle: {
        backgroundColor: Device.isTablet ? 'transparent' : Theme.primaryBackgroundColor
    },
    screenOptions: {
        swipeEnabled: true,
        tabBarStyle: {
            backgroundColor: Device.isTablet ? 'transparent' : Theme.primaryBackgroundColor,
            width: Device.isTablet ? '50%' : '100%',
            alignSelf: 'center'
        },
        tabBarIndicatorStyle: {
            borderBottomColor: Theme.primaryTextColor,
            borderBottomWidth: 3
        },
        tabBarLabelStyle: {
            fontSize: 16,
            fontFamily: Theme.boldFont
        },
        tabBarActiveTintColor: Theme.primaryTextColor,
        tabBarInactiveTintColor: Theme.secondaryTextColor
    }
};

if (Device.isWeb) {
    drawConfig.tabBarComponent = (props) => <TabBarComponent {...props} />;
    drawConfig.tabBarOptions = topTabBarOptionsWeb;
}

const FavoriteSettingsGo = (props) => (
    <Tab.Navigator {...drawConfig} initialRouteName={DEFAULT_FAV_SETTINGS_TAB}>
        <Tab.Screen
            name="manageFavorites"
            options={() => ({
                tabBarLabel: t('SETTINGS.MANAGE_FAVORITES_SELECT').toUpperCase(),
                headerTitle: t('SETTINGS.MANAGE_FAVORITES'),
                tabBarTestID: 'channel_select'
            })}
        >
            {() => <ManageFavorites {...props} />}
        </Tab.Screen>
        <Tab.Screen
            name="channelOrder"
            options={() => ({
                tabBarLabel: t('SETTINGS.CHANNEL_ORDER').toUpperCase(),
                headerTitle: t('SETTINGS.MANAGE_FAVORITES_ORDER'),
                tabBarTestID: 'channel_order'
            })}
        >
            {() => <ChannelOrder {...props} />}
        </Tab.Screen>
    </Tab.Navigator>
);

const FavoriteSettingsIPTV = (props) => (
    <TabIptv.Navigator {...drawConfig} initialRouteName="channelOrder">
        <Tab.Screen
            name="channelOrder"
            options={() => ({
                tabBarLabel: t('SETTINGS.REORDER_CHANNELS_IPTV'),
                headerTitle: t('SETTINGS.REORDER_CHANNELS_IPTV'),
                tabBarTestID: 'channel_order'
            })}
        >
            {() => <ChannelOrder {...props} />}
        </Tab.Screen>
    </TabIptv.Navigator>
);

const FavoriteSettingsTabs = (props) => {
    const { isDeviceIPTV } = props;
    const Container = useMemo(
        () => (isDeviceIPTV ? FavoriteSettingsIPTV : FavoriteSettingsGo),
        [isDeviceIPTV]
    );

    return <Container {...props} />;
};
FavoriteSettingsTabs.propTypes = {
    isDeviceIPTV: PropTypes.bool
};
FavoriteSettingsTabs.defaultProps = {
    isDeviceIPTV: false
};

export default FavoriteSettingsTabs;
